var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 44,
    viewBox: "0 0 512 512",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGray);
export default __webpack_public_path__ + "static/media/gray.0f8dcdc8f32c485f5c0ee97583d5e3f5.svg";
export { ForwardRef as ReactComponent };